import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/Login'
import CreateAccount from '@/views/CreateAccount'
import ForgotPassword from '@/views/ForgotPassword'
import Dashboard from '@/views/Dashboard'
import DashboardOrders from '@/components/dashboard/DashboardOrders'
import DashboardAvailable from '@/components/dashboard/DashboardAvailable'
import DashboardDispatch from '@/components/dashboard/DashboardDispatch'
import Admin from './components/dashboard/Admin'

import store from '@/store'

const _loadComponent = (to, next) => store.state.user.data.auth ? next() : router.push({ name: 'Login' })

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/create',
      name: 'CreateAccount',
      component: CreateAccount
    },
    {
      path: '/forgot',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/dashboard',
      component: Dashboard,
      beforeEnter: (to, from, next) => _loadComponent(to, next),
      children: [
        {
          path: '',
          name: 'Orders',
          component: DashboardOrders
        },
        {
          path: 'available',
          name: 'Available',
          component: DashboardAvailable
        },
        {
          path: 'dispatch',
          name: 'Dispatch',
          component: DashboardDispatch
        },
        {
          path: 'admin',
          name: 'Admin',
          component: Admin
        }
      ]
    },
    {
      path: '*',
      beforeEnter: (to, from, next) => _loadComponent(to, next)
    }
  ]
})

// The cutover flag is read again on every dashboard route change.
router.beforeEach(async (to, from, next) => {
  if (to.path.startsWith('/dashboard') && store.state.user.data.auth) await store.dispatch('cutover/refresh')
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js